<template>
  <div class="discussDetail" v-loading="discussLoading">

<!--    <div class="note-show-head">-->
<!--      <span>{{ discussDetails.theme }}</span>-->
<!--      <span style="font-size: 12px;">{{ discussDetails.createTimeStr }}</span>-->
<!--    </div>-->
<!--    <div class="editorShowArea" v-html="discussDetails.content"></div>-->

    <div class="theme_details_stem">
      <h2>{{ discussDetails.theme }}</h2>
      <div class="editorShowArea" style="min-height: 80px" v-html="discussDetails.content"></div>
      <div class="theme_details_stem_info">
        <span class="theme_details_stem_info_left">
          <span>{{discussDetails.anonymous==1?discussDetails.userName:'匿名用户'}}</span>
          <span>{{discussDetails.createTimeStr}}</span>
        </span>
        <span style="display: flex;">
          <span class="operation_item"  @click="sameQuestion(discussDetails)">
             <span style="padding-right: 5px;">同问</span>
             <span>{{(discussDetails.sameQuestionNum&&discussDetails.sameQuestionNum!=='null')?discussDetails.sameQuestionNum:0}}</span>
          </span>
          <span class="operation_item" title="点赞" @click.stop="replyLiked(discussDetails,'zhuti')">
             <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                <use xlink:href="#icon-dianzan"></use>
             </svg>
             <span>{{ discussDetails.praiseCount && discussDetails.praiseCount !=='null' ? discussDetails.praiseCount:0 }}</span>
          </span>
          <span class="operation_item" title="编辑" @click.stop="getDiscussionToEdt(discussDetails)"
              v-if="discussDetails.createUser === Number(userId)">
             <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                <use xlink:href="#icon-xiugai"></use>
             </svg>
          </span>
					<span class="el-icon-delete operation_item" v-if="discussDetails.isCreateUser||discussDetails.isClassTeacher" @click="deleteDiscuss(discussDetails)" title="删除"></span>
      </span>
      </div>
    </div>


    <el-input
      type="textarea"
      placeholder="欢迎留言交流"
      minHeight="100px"
      show-word-limit
			maxlength="300"
			resize="none"
      v-model="leavingMessage">
    </el-input>
    <div class="note-show-btn">
      <span>
        匿名发表
        <el-switch
          v-model="isAnonymousReply"
          active-color="#1890FF"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </span>
      <el-button size="mini" :disabled="!leavingMessage" @click="publishReply()">发表留言</el-button>
    </div>

    <div>
      <div class="note-goback" style="margin-top: 30px;">
        <span v-if="discussDetails.learnToolReplies">全部回复 {{ discussDetails.learnToolReplies.length }}</span>
        <span></span>
      </div>
      <div class="learnToolRepliesStyle" v-for="(item ,index) in replyList" :key="index + 'learnToolReplies'">
        <p>{{ item.discussionContent }}</p>
        <p class="learnToolRepliesStyleBtn">
          <span>
             <span>{{ item.anonymous === 1 ? item.userName: '匿名用户' }}</span>
             <span>{{ item.replyTimeStr }}</span>
          </span>
          <span style="display: flex;">
            <span class="operation_item" title="点赞" @click.stop="replyLiked(item,'pinglun')">
               <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                  <use xlink:href="#icon-dianzan"></use>
               </svg>
               <span>{{ item.praiseCount && item.praiseCount !=='null' ? item.praiseCount:0 }}</span>
            </span>
            <span class="operation_item" title="评论" @click.stop="replyComment(item)">
               <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                  <use xlink:href="#icon-xiaoxi"></use>
               </svg>
               <span>{{ item.replyNum && item.replyNum !=='null' ? item.replyNum: 0 }}</span>
            </span>
            <span class="el-icon-delete operation_item" v-if="item.isCreateUser||item.teacherFlag" @click="replyDelete(item)" title="删除"></span>
          </span>
        </p>
				<div :class="'comment_list_wrap '+item.className">
				  <div class="comment_area_wrap" v-if="item.deleteFlag==0">
				    <el-input
				      type="textarea"
				      placeholder="我来说几句"
				      maxlength="300"
				      show-word-limit
							resize="none"
				      v-model="item.commentValue"
				      @keyup.native="editComment(item)" class="comment_area">
				    </el-input>
				    <el-checkbox v-model="item.anonymousValue" v-if="!isShowAnonymous">匿名发表</el-checkbox>
				    <el-button :disabled="(item.commentValue&&item.commentValue.trim()!='')?false:true" @click="publishComment(item)">发表评论</el-button>
				    <div style="clear: both;border-bottom: 1px solid #E6E6E6;"></div>
				  </div>
				  <div class="comment_list">
				    <ul>
				      <li class="comment_list_lis" v-for="(v,i) in item.pinglunList" :key="i">
				        <div class="comment_list_title">
				          <p v-html="v.discussionContent"></p>
				        </div>
				        <div class="comment_list_footer">
				          <div class="comment_list_left">
				            <span class="comment_name">{{v.anonymous==1?v.userName:'匿名用户'}}</span>
				            <span class="comment_type" v-if="v.userType==0||v.userType==1">教师</span>
				            <span class="comment_time">{{v.replyTimeStr}}</span>
				          </div>
				          <div class="comment_list_right">
				            <ol>
				              <li :class="v.isPraise?'comment_liked_ck':'comment_liked'" class="" @click="likedComment(v)">
				                <i></i>
				                <span>{{v.praiseCount}}</span>
				              </li>
				              <li class="comment_delete" @click="deleteComment(v,item)" v-if="v.isCreateUser||v.teacherFlag">
				                <i></i>
				              </li>
				            </ol>
				          </div>
				        </div>
				      </li>
				    </ul>
				  </div>
				</div>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   *     讨论的详情，回复点赞查看。
   *    wjl 2022.8.16
   */
  import * as api from "@/api/discussApi";

  export default {
    name: "discussDetail",
    props: {
      discussId: {
        type: [String, Number],
        default: '',
      },
      query: {
        type: Object,
        default: () => {
        },
      }
    },
    data() {
      return {
        userType: sessionStorage.getItem('userType'),
        userId: sessionStorage.getItem('userId'),
        discussLoading: false,
        //
        leavingMessage: '',
        isAnonymousReply: 1,
        discussDetails: {},

        //
        isShowAnonymous: sessionStorage.getItem('userType') <= 1?true:false,
        sameQuestionFlag: true,
        likedDiscussFlag: true,
        likedCommentFlag: true,
        replyLikedFlag: true,
				replyList: []
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.discussLoading = true;
        let obj = {
          courseId: this.query.courseId,
          classId: this.query.classId,
          // catalogId: this.query.catalogId,
          id: this.discussId,
        }
        api.getReplyList(obj).then(res => {
          if (res.code == 0) {
            this.discussDetails = res.data;
						this.replyList = []
						this.discussDetails.learnToolReplies.forEach((v,i)=>{
						  let replyObj = {
						    anonymous: v.anonymous,
						    deleteFlag: v.deleteFlag,
						    discussionContent: this.$replace.replaceMark(v.discussionContent),
						    id: v.id,
						    isCreateUser: v.isCreateUser,
						    isPraise: v.isPraise,
						    praiseCount: v.praiseCount,
						    replyNum: v.replyNum,
						    replyTimeStr: v.replyTimeStr,
						    teacherFlag: v.teacherFlag,
						    userName: v.userName,
						    userType: v.userType,
						    className: '',
						    anonymousValue: false,
						    pinglunList: []
						  }
						  this.replyList.push(replyObj)
						})
          }
        }).catch(error => console.log(error))
          .finally(() => this.discussLoading = false)
      },
      // 同问
      sameQuestion(item){
        if(this.sameQuestionFlag){
          this.sameQuestionFlag = false
          item.isSameQuestion = !item.isSameQuestion
          let obj = {
            discussionId: item.id,
            isAdd: item.isSameQuestion
          }
          api.sameQuestion(obj).then(rs=>{
            if(rs.code==0){
              item.isSameQuestion?item.sameQuestionNum++:item.sameQuestionNum--
              this.sameQuestionFlag = true
            }else{
              this.$messageError(rs.msg)
              this.sameQuestionFlag = true
            }
          }).catch(err=>{
            this.sameQuestionFlag = true
          })
        }
      },
      // 留言
      publishReply() {
        let obj = {
          learnId: this.discussId,
          type: 0,
          discussionContent: this.leavingMessage,
          anonymous: this.isAnonymousReply, // 0:匿名,1:非匿名
          courseId: this.query.courseId,
          classId: this.query.classId,
          operationType: 2 // 1删除、2新增
        }
        api.publishDeleteReply(obj).then(rs => {
          if (rs.code == 0) {
            this.leavingMessage = '';
            this.init();
          }
        }).catch(err => {
          console.log(err)
        })
      },

      // 给回复内容点赞
      replyLiked(item,type) {
				if(type == 'pinglun'){
					if (item.deleteFlag) {
					  let str = item.isPraise ? '该回复已删除，无法取消点赞' : '该评论已删除，无法点赞'
					  this.$messageWarning(str)
					  return
					}
					item.isPraise = !item.isPraise
					let obj = {
					  learnId: this.discussId,
					  isAdd: item.isPraise,
					  replyId: item.id
					}
					api.likedDiscuss(obj).then(rs => {
					  if (rs.code == 0) {
					    item.isPraise ? item.praiseCount++ : item.praiseCount--
					  } else {
					    this.$messageError(rs.msg)
					
					  }
					}).catch(err => {
					  console.log(err)
					})
				}else{
					this.discussionSamePraise(item)
				}
        
      },
			// 给讨论点赞
			discussionSamePraise(item) {
			  item.isPraise = !item.isPraise
			  let obj = {
			    learnId: item.id,
			    isAdd: item.isPraise,
			  }
			  api.likedDiscuss(obj).then(rs => {
			    if (rs.code == 0) {
			      item.isPraise ? item.praiseCount++ : item.praiseCount--
			    } else {
			      this.$messageError(rs.msg)
			    }
			  }).catch(() => {
			  })
			},
			replyComment(item){
			  if(item.deleteFlag==1&&item.replyNum==0){
			    if(item.replyNum==0){
			      this.$messageWarning('该回复下暂无可查看的评论');
			    }
			    return
			  }
			  let that = this
			  let obj = {
			    id: item.id,
			    learnId: this.discussId,
			    courseId: this.query.courseId,
			    classId: this.query.classId,
			  }
			  if(item.className==''){
			    item.className = 'active';
			    api.replyComment(obj).then(rs=>{
			      if(rs.code==0){
			        if(rs.data.length>0){
			          item.pinglunList = []
			          rs.data.forEach((v,i)=>{
			            let commentObj = {
			              anonymous: v.anonymous,
			              deleteFlag: v.deleteFlag,
			              discussionContent: that.$replace.replaceMark(v.discussionContent),
			              id: v.id,
			              isCreateUser: v.isCreateUser,
			              isPraise: v.isPraise,
			              learnId: that.detailsId,
			              praiseCount: v.praiseCount,
			              replyId: item.id,
			              replyTimeStr: v.replyTimeStr,
			              teacherFlag: v.teacherFlag,
			              userName: v.userName,
			              userType: v.userType,
			              isComment: false
			            }
			            item.pinglunList.push(commentObj)
			          })
			        }else{
			          item.pinglunList = []
			        }
			      }else{
			        this.$messageError(rs.msg)
			        item.pinglunList = []
			      }
			    }).catch(err=>{
			      console.log(err)
			    })
			  }else{
			    item.className = ''
			  }
			},
			deleteDiscuss(item){
				let tipsMsg = ''
				let tipsContent = ''
				let tipsSettings = {}
				let isDelete = false
				if(item.isClassTeacher){
				  tipsMsg = '确定删除该主题吗？'
				  tipsContent = '确定后将删除该回复下的全部评论'
				  isDelete = true
				}else{
				  if(item.replyCount>0){
				    tipsMsg = '该主题已有回复，无法删除'
				    tipsContent = '如需删除，请联系老师！'
				    isDelete = false
				    tipsSettings = {
				      showCancelButton: false
				    }
				  }else{
				    tipsMsg = '确定删除该主题吗？'
				    tipsContent = ''
				    isDelete = true
				  }
				}
				this.$tipsDialog(
				  "提示",
				  tipsMsg,
				  tipsContent,
				  "el-icon-warning",
				  "rgb(255, 178, 60)",
				  tipsSettings
				).then(() => {
				  if(isDelete){
				  	api.deleteDiscussion(item.id).then(rs=>{
				      if(rs.code==0){
				        this.$messageSuccess('删除成功')
				        this.$parent.cancelEditor();
				      }else{
				        this.$messageError(rs.msg)
				      }
				    }).catch(err=>{
				      console.log(err)
				    })
				  }else{
				    console.log('无法删除')
				  }
				}).catch(() => {
				  console.log('cancel')
				});
			},
      // 删除回复
      replyDelete(item) {

        this.$confirm('确定删除该回复吗', '删除回复', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let obj = {
            id: item.id,
            learnId: this.discussId,
            operationType: 1 // 1删除、2新增
          }
          api.publishDeleteReply(obj).then(rs => {
            if (rs.code == 0) {
              this.$messageSuccess('删除成功')
              this.init()
            } else {
              this.$messageError(rs.msg)
            }
          }).catch(err => {
            console.log(err)
          })

        }).catch(() => {
        });
      },
			publishComment(item){
			  let that = this
			  let obj = {
			    learnId: this.discussId,
			    type: 0,
			    discussionContent: item.commentValue,
			    replyId: item.id,
			    anonymous: item.anonymousValue?0:1,
			    courseId: this.query.courseId,
			    classId: this.query.classId,
			    operationType: 2
			  }
			  api.deletePublishComment(obj).then(rs=>{
			    if(rs.code==0){
			      let commentObj = {
			        anonymous: rs.data.anonymous,
			        deleteFlag: rs.data.deleteFlag,
			        discussionContent: that.$replace.replaceMark(rs.data.discussionContent),
			        id: rs.data.id,
			        isCreateUser: true,
			        praiseCount: 0,
			        replyId: rs.data.replyId,
			        replyNum: 0,
			        replyTimeStr: rs.data.replyTimeStr,
			        teacherFlag: rs.data.teacherFlag,
			        userName: rs.data.userName,
			        userType: rs.data.userType,
			      }
			      item.pinglunList.unshift(commentObj)
			      item.replyNum = item.replyNum+1
			    }else{
			      this.$messageError(rs.msg)
			    }
			    item.commentValue = ''
			    item.anonymousValue = false
			  }).catch(err=>{
			    console.log(err)
			  })
			},
			editComment(item){
			  let val = item.commentValue!=undefined ? item.commentValue.trim() : ''
			  if(val!=''){
			    item.isComment = false
			  }else{
			    item.isComment = true
			  }
			},
			likedComment(item){
			  if(this.likedCommentFlag){
			    this.likedCommentFlag = false
			    item.isPraise = !item.isPraise
			    let obj = {
			      learnId: this.discussId,
			      isAdd: item.isPraise,
			      replyId: item.id
			    }
			    api.likedDiscuss(obj).then(rs=>{
			      if(rs.code==0){
			        item.isPraise?item.praiseCount++:item.praiseCount--
			        this.likedCommentFlag = true
			      }else{
			        this.$messageError(rs.msg)
			        this.likedCommentFlag = true
			      }
			    }).catch(err=>{
			      console.log(err)
			      this.likedCommentFlag = true
			    })
			  }
			},
			deleteComment(item,items){
			  this.$tipsDialog(
			    "提示",
			    "确定删除该评论吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
			  ).then(() => {
			    let obj = {
			      id: item.id,
			      learnId: this.discussId,
			      replyId: item.replyId,
			      operationType: 1
			    }
			    api.deletePublishComment(obj).then(rs=>{
			      if(rs.code==0){
			        this.$messageSuccess('删除成功')
			        this.init()
			      }else{
			        this.$messageError(rs.msg)
			      }
			    }).catch(err=>{
			      console.log(err)
			    })
			  }).catch(() => {
			    console.log('cancel')
			  });
			},
			// 编辑讨论
			getDiscussionToEdt(item){
				this.$emit('getDiscussionToEdt',item)
			}
    }
  }
</script>

<style scoped lang="scss">
  .discussDetail {

    .theme_details_stem{
      border:1px solid rgba(230,230,230,1);
      border-radius:4px;
      margin-top: 12px;
      margin-bottom: 16px;
      position: relative;
      padding: 10px;

      .theme_details_stem_info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        .theme_details_stem_info_left{
          display: flex;
          align-items: center;
          font-size:12px;
          font-weight:400;
          color:rgba(153,153,153,1);
        }
      }
    }

    .note-show-head {
      border-left: solid 5px #1d70e2;
      padding-left: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .note-show-btn {
      font-size: 12px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .learnToolRepliesStyle {
      border-bottom: 1px solid #E6E6E6;
      margin-bottom: 16px;

      .learnToolRepliesStyleBtn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 46px;
        font-size: 12px;
        color: #666666;

        svg {
          margin-right: 5px;
          fill: #666666;
        }
      }
			.comment_list_wrap{
			  width:100%;
			  height: 0;
			  background:rgba(244,244,244,1);
			  position: relative;
			  overflow: hidden;
			  &::after,&::before{
			    position:absolute;
			    content:'';
			    border:10px solid;
			  }
			  &::before{
			    right: 100px;
			    top: -20px;
			    border-color: transparent transparent #E6E6E6 transparent ;
			  }
			  &::after{
			    border-color: transparent transparent #F4F4F4 transparent ;
			    right: 100px;
			    top: -18px;
			  }
			  .comment_area_wrap{
			    padding: 0 16px;
			    .comment_area{
			      width: 100%;
			      border-radius:4px;
			      margin: 12px 0;
			      .el-textarea__inner{
			        resize: none;
			        max-height: 84px;
			        background: #fff;
			        border:1px solid rgba(230,230,230,1);
			        font-size:12px;
			        font-weight:400;
			        color:rgba(153,153,153,1);
			        &:focus{
			          background: #fff;
			        }
			      }
			    }
			    button{
			      padding: 0;
			      width:72px;
			      height:30px;
			      border-radius:4px;
			      background:rgba(255,255,255,1);
			      border:1px solid rgba(83,151,247,1);
			      font-size:12px;
			      font-weight:400;
			      color:rgba(83,151,247,1);
			      float: right;
			      margin-bottom: 16px;
			    }
			    .el-button.is-disabled{
			      background:rgba(230,230,230,1);
			      color: #999999;
			      border: none;
			    }
			  }
			  .comment_list{
			    margin-top: 16px;
			    ul{
			      padding: 0 16px;
			      margin: 0;
			      .comment_list_lis{
			        border-bottom: 1px solid #E6E6E6;
			        .comment_list_title{
			          font-size:14px;
			          font-weight:400;
			          color:rgba(51,51,51,1);
			          margin-top: 16px;
			          word-break: break-all;
			        }
			        .comment_list_footer{
			          display: flex;
			          justify-content: space-between;
			          align-items: center;
			          min-height: 46px;
			          .comment_list_left{
			            .comment_name{
			              font-size:14px;
			              font-weight:400;
			              color:rgba(153,153,153,1);
			            }
			            .comment_type{
			              font-size:12px;
			              font-weight:400;
			              color:rgba(83,151,247,1);
			              background: #E8F2FF;
			              padding: 3px 6px;
			              margin-left: 8px;
			            }
			            .comment_time{
			              font-size:12px;
			              font-weight:400;
			              color:rgba(153,153,153,1);
			              margin-left: 40px;
			            }
			          }
			          .comment_list_right{
			            ol{
			              display: flex;
			              li{
			                cursor: pointer;
			                padding: 0 24px;
			                border-left: 1px solid #E6E6E6;
			                line-height: 12px;
			                display: flex;
			                align-items: center;
			                i{
			                  width: 14px;
			                  height: 14px;
			                  display: inline-block;
			                }
			                span{
			                  font-size:12px;
			                  font-weight:400;
			                  color:rgba(153,153,153,1);
			                  margin-left: 6px;
			                }
			              }
			              .comment_liked{
			                border-left: none;
			                i{
			                  background: url('/static/images/study/icon/dianzan_hv.png') no-repeat;
			                  background-size: 100%;
			                }
			                &:hover{
			                  i{
			                    background: url('/static/images/study/icon/dianzan.png') no-repeat;
			                    background-size: 100%;
			                  }
			                  span{
			                    color: #5397F7;
			                  }
			                }
			              }
			              .comment_liked_ck{
			                border-left: none;
			                i{
			                  background: url('/static/images/study/icon/dianzan.png') no-repeat;
			                  background-size: 100%;
			                }
			                span{
			                  color: #5397F7;
			                }
			              }
			              .comment_comment{
			                i{
			                  background: url('/static/images/study/icon/pinglun_hv.png') no-repeat;
			                  background-size: 100%;
			                }
			                &:hover{
			                  i{
			                    background: url('/static/images/study/icon/pinglun.png') no-repeat;
			                    background-size: 100%;
			                  }
			                  span{
			                    color: #5397F7;
			                  }
			                }
			              }
			              .comment_delete{
			                i{
			                  background: url('/static/images/study/icon/shanchu_hv.png') no-repeat;
			                  background-size: 100%;
			                }
			                &:hover{
			                  i{
			                    background: url('/static/images/study/icon/shanchu.png') no-repeat;
			                    background-size: 100%;
			                  }
			                }
			              }
			            }
			          }
			        }
			      }
			    }
			  }
			}
			.comment_list_wrap.active{
			  height: auto;
			  border:1px solid rgba(230,230,230,1);
			  margin-top: 10px;
			  margin-bottom: 16px;
			}
    }


    .operation_item {
      margin: 0 10px;
      color: #acacac;
      display: flex;
      align-items: center;
      font-size: 12px;
      cursor: pointer;

      svg {
        margin-right: 5px;
        fill: #acacac;
      }
    }

    .note-goback {
      margin-bottom: 15px;
      border-bottom: 1px solid #E6E6E6;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/IT/components/discussDetail.vue